import {useEffect, useRef} from 'react';
import { StaticTable } from '../../templates/tables/StaticTable';
import * as con from "../../GlobalConstants";
import "./../ComponentsGlobalStyle.css";
import { RefApplicationParameterHook } from '../hooks/ApplicationParametersHooks';
import { nonZeroTranactionFunction, prepareForExport, selectedTransactionCols } from '../../utils/transactionFunctions';
import { RefTransactionsSummaryTableHook } from '../hooks/TransactionsSummaryTableHook';
import { TransactionColumnsHook } from '../hooks/TransactionsHooks';
import { Button } from '@blueprintjs/core';
import { downloadExcelFromArray } from '../../utils/downloadFunctions';
import { buildTransactionsSummaryDownloadFileName } from '../../GlobalFunctions';
import { createNotification } from '../../templates/notifications/Notifications';
import TransactionExtractionLoadingIcons from '../transactions/TransactionExtractionLoadingIcons';
import { constructFileName } from '../../utils/reportFunctions';
import LoadingOverlay from '../modales/LoadingOverlay';
import { useSelector } from 'react-redux';
import { selectAllTransactionsOk } from '../../store/selectors/transactionsSelectors';

export const TransactionsSummary = ({
  selectedColumns = selectedTransactionCols,
  fixedSize = null,
  forcedVisualizationPeriodicity,
  includeAllRows = false,
  filterByBands = true,
  includeDownloadButton = true,
  compress = false
}) => {

  const [transactionSummaryObject, summaryRow, computing, hasSummaryTable] =
    RefTransactionsSummaryTableHook({ forcedVisualizationPeriodicity });
  
  const prevComputingRef = useRef(computing);

  useEffect(() => {
    if (prevComputingRef.current === true && computing === false) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          createNotification("Datos cargados correctamente");
        });
      });
    }
    prevComputingRef.current = computing;
  }, [computing]);

  let transactionsCol = TransactionColumnsHook(selectedColumns, filterByBands);
  const showDetails = RefApplicationParameterHook(con.SHOW_DETAILS);

  if (!showDetails) {
    const columnsToHide = [
      con.FWD_COVERAGE_AMOUNT,
      con.FWD_COVERAGE_RATE,
      con.DIRECT_DELTA,
      con.OPTION_COVERAGE_AMOUNT,
      con.OPTION_COVERAGE_RATE,
      con.COUNTER_DELTA
    ];
    transactionsCol = transactionsCol.filter(col => !columnsToHide.includes(col[con.ID]));
  }

  const onlyNonZeroRows = RefApplicationParameterHook(con.ONLY_NON_ZERO_ROWS);
  const selectedBand = RefApplicationParameterHook(con.SELECTED_BAND);
  const transactionsLoaded = useSelector(selectAllTransactionsOk)

  return (
    <div style={{ marginBottom: "2vh" }}>
      {
        (!transactionsLoaded) ?
          <TransactionExtractionLoadingIcons />
          : computing ? <LoadingOverlay/>
            :(!hasSummaryTable) ? <h4>{con.NO_TRANSACTIONS_MESSAGE}</h4>
              : <div>
                  <StaticTable
                    columnArray={transactionsCol}
                    dataDictionary={transactionSummaryObject}
                    summaryRow={summaryRow}
                    fixedSize={fixedSize}
                    compress={compress}
                    filterFunction={ob =>
                      includeAllRows ||
                      !onlyNonZeroRows ||
                      nonZeroTranactionFunction(ob)
                    }
                  />
                  <div style={{ marginTop: "10px" }}>
                    {includeDownloadButton &&
                      <Button
                        icon="download"
                        text="Descargar"
                        onClick={() => {
                          downloadExcelFromArray(
                            prepareForExport(transactionSummaryObject, transactionsCol),
                            constructFileName(
                              buildTransactionsSummaryDownloadFileName(selectedBand),
                              con.XLSX_FILE_TYPE
                            )
                          )
                          createNotification("Resumen descargado")
                        }}
                      />
                    }
                  </div>
                </div>
      }
    </div>
  );
}
